import { render, staticRenderFns } from "./copy_meal.vue?vue&type=template&id=6dd3c3aa&scoped=true&lang=html&"
import script from "./copy_meal.vue?vue&type=script&lang=js&"
export * from "./copy_meal.vue?vue&type=script&lang=js&"
import style0 from "./copy_meal.vue?vue&type=style&index=0&id=6dd3c3aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3c3aa",
  null
  
)

export default component.exports